import { Grid, Item } from "@mui/material";
import WwCol from "./WwCol";

const WwRow = (props) => {
  return (
    <>
      {props.data && (
        <Grid
          container
          id={props.data.myId.self}
          style={{
            display:
              props.initHide &&
              props.initHide.indexOf(props.data.myId.self) > -1
                ? "none"
                : "flex",
          }}
        >
          {props.data.items &&
            props.data.items.map((innerDiv, index) => {
              return (
                <>
                  {innerDiv.type && innerDiv.type == "row" && (
                    <WwRow data={innerDiv} initHide={props.initHide}>
                      12
                    </WwRow>
                  )}
                  {innerDiv.type && innerDiv.type == "column" && (
                    <Grid
                      item
                      xs={
                        Math.round(innerDiv.style.width.split("%")[0] * 12) /
                        100
                      }
                      sx={{
                        display: "inline-block",
                        width: "inherit",
                        alignSelf: innerDiv.mime ? "center" : "flex-start",
                      }}
                    >
                      {" "}
                      <WwCol
                        data={innerDiv}
                        component={innerDiv.mime}
                        initHide={props.initHide}
                      ></WwCol>
                    </Grid>
                  )}
                </>
              );
            })}
        </Grid>
      )}
    </>
  );
};

export default WwRow;
